<template>
  <div class="ghost-reservation card">
    <div class="card-body">
      <h5 class="card-title">Add Ghost Reservation</h5>
      <div class="activity-box ghost-activity">👻 Ghost Reservation</div>
      <div class="position-relative">
        <input
            type="text"
            id="clientSearch"
            v-model="searchQuery"
            class="form-control"
            placeholder="Search by name or email"
            @input="searchClients"
            @keydown.down.prevent="highlightNext"
            @keydown.up.prevent="highlightPrevious"
            @keydown.enter.prevent="selectClient"
            autocomplete="off"
            autocorrect="off" 
            spellcheck="false" 
            aria-autocomplete="list" 
            aria-controls="dropdown-list" 
          />

        <ul v-if="filteredClients.length" class="dropdown-list">
          <li
            v-for="(client, index) in filteredClients"
            :key="client.clientid"
            :class="{ highlighted: index === highlightedIndex, 'duplicate-id': client.duplicateZauiId }"
            @click="selectClient(index)"
            @mouseenter="highlightIndex(index)"
          >
            <div class="client-name">
              {{ client.person.firstname }} {{ client.person.lastname }} ({{ client.person.email }})
              <span v-if="client.duplicateZauiId" class="duplicate-warning" title="Another result shares this same Zaui id - check you're picking the right one">⚠️ shared Zaui id</span>
            </div>
            <div class="client-details">
              <span v-if="client.person.zauiclientid">Zaui id: {{ client.person.zauiclientid }}</span>
              <span v-else class="no-zaui-id">no Zaui id</span>
              <span v-if="client.person.dateofbirth"> · DOB: {{ formatDate(client.person.dateofbirth) }}</span>
              <span v-if="client.lastFlownOn"> · last flown: {{ formatDate(client.lastFlownOn) }}</span>
              <span v-else> · never flown with a real booking</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ClientsDataService from "@/services/ClientsDataService";

export default {
  name: "GhostReservation",
  data() {
    return {
      searchQuery: "",
      filteredClients: [],
      highlightedIndex: 0,
      isLoading: false,
    };
  },
  methods: {
    async searchClients() {
      if (this.searchQuery.trim() === "") {
        this.filteredClients = [];
        this.highlightedIndex = 0;
        return;
      }
      try {
        const response = await ClientsDataService.findByName(this.searchQuery);
        this.filteredClients = response.data.clients || [];
        this.highlightedIndex = 0;
      } catch (error) {
        console.error("Error searching clients:", error);
      }
    },
    highlightNext() {
      if (this.highlightedIndex < this.filteredClients.length - 1) {
        this.highlightedIndex++;
      }
    },
    highlightPrevious() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      }
    },
    highlightIndex(index) {
      this.highlightedIndex = index;
    },
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleDateString();
    },
    selectClient(index = this.highlightedIndex) {
      const client = this.filteredClients[index];
      if (!client) return;

      this.$emit("saveGhost", {
        reservationid: `ghost-${Date.now()}`,
        clientName: `${client.person.firstname} ${client.person.lastname}`,
        email: client.person.email,
        activityName: "Ghost Reservation",
        personid: client.personid,
        weight: client.person.weight || "N/A",
        groupcode: null,
      });

      this.resetForm();
    },
    resetForm() {
      this.searchQuery = "";
      this.filteredClients = [];
      this.highlightedIndex = 0;
    },
  },
};
</script>

<style scoped>
.ghost-reservation {
  max-width: 350px;
  margin: 1rem auto;
}

.activity-box {
  border-radius: 10px;
  padding: 5px 10px;
  margin-bottom: 15px;
  background-color: #f2f2f2;
  color: #333;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ghost-activity {
  background-color: #e0e0e0;
}

.position-relative {
  position: relative;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 150px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  z-index: 1000;
  margin-top: 5px;
  padding: 0;
  list-style: none;
}

.dropdown-list li {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-list li:hover,
.dropdown-list li.highlighted {
  background-color: #f0f0f0;
  font-weight: bold;
}

.dropdown-list li.duplicate-id {
  background-color: #fff3cd;
}

.client-details {
  font-size: 0.8em;
  font-weight: normal;
  color: #666;
}

.no-zaui-id {
  color: #999;
  font-style: italic;
}

.duplicate-warning {
  font-size: 0.8em;
  font-weight: bold;
  color: #856404;
  margin-left: 6px;
}
</style>
